import {AggregationProps} from "./aggregations";
import { renderField } from "./utils";

export type TermsAggProps = AggregationProps & {
  field: string
  size?: number
}

export type VariableWidthHistogramProps = AggregationProps & {
  field: string
  buckets: number
};

export const terms = (props: TermsAggProps): string => {
  return `
    {
      name: "${props.name}"
      value: {
        terms: {
          field: "${props.field}"
          ${renderField('size', props.size)}
        }
      }
    }`;
};

export const variableWidthHistogram = (props: VariableWidthHistogramProps): string => {
  return `
    {
      name: "${props.name}"
      value: {
        variable_width_histogram: {
          field: "${props.field}",
          buckets: ${props.buckets}
        }
      }
    }`;
};
